"use client";

import { ColorPicker } from "@/components/admin/content/ColorPicker";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { Switch } from "@/components/ui/switch";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    admin?: boolean;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    assets: IAccountAssets[];
    user: IUserData;
}
export default function KickCustomization({
    block,
    blockUpdate,
    update,
    assets,
    user,
}: Props) {
    const onChangeBackgroundColor = (value: string) => {
        update({
            ...block,
            colour: {
                ...block.colour,
                background: value,
            },
        });
    };
    const onChangeTextColor = (value: string) => {
        update({
            ...block,
            colour: {
                ...block.colour,
                text: value,
            },
        });
    };

    return (
        <div className="flex flex-col gap-3">
            <div className="flex w-full flex-col gap-3">
                <div className="flex w-full flex-col gap-3">
                    <CardSetting title="Customization" noBorder>
                        <div className="flex items-center justify-between">
                            <Label variant="toggle">Custom theme</Label>
                            <Switch
                                onCheckedChange={(checked) =>
                                    update({
                                        ...block,
                                        colour: {
                                            ...block.colour,
                                            toggle: checked,
                                        },
                                    })
                                }
                                checked={block.colour.toggle}
                            />
                        </div>
                        {block.colour.toggle && (
                            <div className="flex flex-col gap-3">
                                <div className="flex items-center justify-between gap-4 pt-3">
                                    <div className="">
                                        <Label>Background</Label>
                                    </div>
                                    <Popover>
                                        <PopoverTrigger asChild>
                                            <Button
                                                className="h-9 w-9 rounded-full border-2 border-primary"
                                                style={{
                                                    background:
                                                        block.colour.background,
                                                }}
                                            ></Button>
                                        </PopoverTrigger>
                                        <PopoverContent className="z-[999]">
                                            <ColorPicker
                                                gradient
                                                value={block.colour.background}
                                                onChange={
                                                    onChangeBackgroundColor
                                                }
                                            />
                                        </PopoverContent>
                                    </Popover>
                                </div>
                                <Separator />
                                <div className="flex items-center justify-between gap-4">
                                    <div className="">
                                        <Label>Text color</Label>
                                    </div>
                                    <Popover>
                                        <PopoverTrigger asChild>
                                            <Button
                                                className="h-9 w-9 rounded-full border-2 border-primary"
                                                style={{
                                                    background:
                                                        block.colour.text,
                                                }}
                                            ></Button>
                                        </PopoverTrigger>
                                        <PopoverContent className="z-[999]">
                                            <ColorPicker
                                                value={block.colour.text}
                                                onChange={onChangeTextColor}
                                            />
                                        </PopoverContent>
                                    </Popover>
                                </div>
                            </div>
                        )}
                    </CardSetting>
                </div>
            </div>
        </div>
    );
}
